import { api } from "../App";
import { SET_PROFOTBOR_CURRENT, SET_PROFOTBOR_LIST, SET_PROFOTBOR_LOADING, SET_PROFOTBOR_ORGANIZATION, SET_PROFOTBOR_SPECIALITY, SET_PROFOTBOR_STUDENTS } from "./types";



export const getList = () => async (dispatch) => {
  try {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: true });
    const { data } = await api.get('/profotbor')
    dispatch({ type: SET_PROFOTBOR_LIST, payload: data })
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: false });
  }
}

export const getCurrent = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: true });
    const { data } = await api.get(`/profotbor/${id}`)
    dispatch({ type: SET_PROFOTBOR_CURRENT, payload: data })
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: false });
  }
}

export const createEntity = (data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: true });
    const response = await api.post('/profotbor', data);
    success = response.data.id
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: false });
    return success
  }
}

export const updateEntity = (id, data) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: true });
    await api.put(`/profotbor/${id}`, data);
    await dispatch(getCurrent(id))
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: false });
    return success
  }
}

export const deleteEntity = (id) => async (dispatch, getState) => {
  let success
  try {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: true });
    await api.delete(`/profotbor/${id}`);
    await dispatch(getList())
    success = true
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_PROFOTBOR_LOADING, payload: false });
    return success
  }
}

export const getOrganizations = () => async (dispatch) => {
  try {
    const { data } = await api.get('/api/library/location/university')
    dispatch({ type: SET_PROFOTBOR_ORGANIZATION, payload: data })
  } catch (ERR) {
  } finally {
  }
}

export const getSpeciality = () => async (dispatch) => {
  try {
    const { data } = await api.get('/api/library/education/speciality')
    dispatch({ type: SET_PROFOTBOR_SPECIALITY, payload: data })
  } catch (ERR) {
  } finally {
  }
}

export const getStudents = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`/profotbor/${id}/students`)
    dispatch({ type: SET_PROFOTBOR_STUDENTS, payload: data })
  } catch (ERR) {
  } finally {
  }
}

export const addStudent = (id, data) => async (dispatch, getState) => {
  let success
  try {
    await api.post(`/profotbor/${id}/students`, data)
    dispatch(getCurrent(id))
    success = true
  } catch (ERR) {
  } finally {
    return success
  }
}

export const deleteStudent = (id, memberId) => async (dispatch, getState) => {
  try {
    await api.delete(`/profotbor/students/${memberId}`)
    dispatch(getCurrent(id))
  } catch (ERR) {
  } finally {
  }
}